import { render, staticRenderFns } from "./selfGoodsDetail.vue?vue&type=template&id=591bc7ce&scoped=true"
import script from "./selfGoodsDetail.vue?vue&type=script&lang=js"
export * from "./selfGoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./selfGoodsDetail.vue?vue&type=style&index=0&id=591bc7ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591bc7ce",
  null
  
)

export default component.exports